import React from "react";
import MyCard7 from "../../tools/MyCard7";
import { Mail, Phone, User } from "lucide-react";
import { MyColors } from "../../util/my_colors";
import { Email } from "@mui/icons-material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";
import MyDropList2 from "../../tools/MyDropList2";
import YtCard from "../../tools/YtCard";
import PostCard from "../../tools/PostCard";

export default function InfluencerInfo() {
  return (
    <div className="w-full flex flex-col ">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* General card */}
        <MyCard7 className="p-4 flex flex-col">
          <div className="flex items-center justify-start ">
            <YouTubeIcon
              className={`mr-2  ${MyColors.red.text}`}
              sx={{ fontSize: 24 }}
            />

            <span className="text-sm font-medium font-sans text-slate-700 dark:text-slate-400">
              General Detail
            </span>
          </div>
          <div className="flex mt-2 space-x-4">
            <img
              className="w-20 h-20 rounded-full object-cover "
              src="https://images.pexels.com/photos/37296768/pexels-photo-37296768.jpeg"
              alt=""
            />
            <div className="flex flex-col text-slate-200 items-start justify-start">
              <span className="text-lg ">Moon</span>
              <div className="flex items-center justify-center text-sm space-x-1 text-slate-400">
                <Mail size={14} />
                <span>moon123app@gmail.com</span>
              </div>
              <div className="flex items-center justify-center text-sm space-x-1 text-slate-400">
                <Phone size={14} />
                <span>+91878765433</span>
              </div>
              <div className="flex items-center justify-center text-sm space-x-0 text-slate-400">
                <WhatsAppIcon className="h-1 w-1" sx={{ fontSize: 18 }} />
                <span>+91878765433</span>
              </div>
            </div>
          </div>
        </MyCard7>
        {/* Professional Card */}
        <MyCard7 className="p-4 flex flex-col">
          <div className="flex items-center justify-start ">
            <User className={`w-4 h-4 mr-2  ${MyColors.blue.text}`} />
            <span className="text-sm font-medium font-sans text-slate-700 dark:text-slate-400">
              Professional Detail
            </span>
            <MyDropList2
              options={[
                { label: "Panda King", value: "network" },
                { label: "Mangocash", value: "name" },
              ]}
              className="w-40 text-slate-100 ml-auto flex items-center"
              //  value={sortBy}
              onChange={(tab) => {
                //    setSortBy(tab.value);
              }}
            />
          </div>
          <div className="flex mt-2 space-x-4">
            <div className="grid grid-cols-4 items-start justify-start gap-2 w-full">
              <span className="text-sm col-span-1 text-slate-300 font-medium tracking-wider">
                Login Email
              </span>
              <span className="text-sm col-span-3 text-slate-400  ">
                : moon12233gaf@gmail.com
              </span>
              <span className="text-sm col-span-1 text-slate-300 font-medium tracking-wider">
                Total Referral
              </span>
              <span className="text-sm col-span-3 text-slate-400  ">: 554</span>
              <span className="text-sm col-span-1 text-slate-300 font-medium tracking-wider">
                Total Coins
              </span>
              <span className="text-sm col-span-3 text-slate-400  ">
                : 1212212
              </span>
            </div>
          </div>
        </MyCard7>
      </div>
      <YtCard
        className="p-4 mt-4"
        viewCount={23}
        videoCount={23}
        subscriberCount={23323}
        joinedDate={"12 June 2026"}
      />
      <PostCard className={"p-4 mt-4"}/>
    </div>
  );
}
